module.exports = __webpack_public_path__ + "img/buy-oc-plus-intro.9a57cb2.png";